import { render, staticRenderFns } from "./InspectDeviceDetail.vue?vue&type=template&id=2772b26b&scoped=true&"
import script from "./InspectDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./InspectDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./InspectDeviceDetail.vue?vue&type=style&index=0&id=2772b26b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772b26b",
  null
  
)

export default component.exports